import React from 'react';
import queryString from 'query-string';
import { Glyphicon, Row, Col, FormGroup } from 'react-bootstrap';
import { Label, ValidationError, Button } from 'fw/components';
import { Form, PasswordBox } from 'fw/forms';
import { PasswordInstructions } from 'areas/shared/components';
import SecurityQuestions from './SecurityQuestions';
import Loading from 'layouts/public/loading/Loading'
import Completed from 'layouts/public/completed/Completed'
import * as API from 'modules/app/API'
import * as Notifications from 'fw/globals/Notifications';
import * as Modals from 'fw/globals/Modals'

class RestorePassword extends React.Component {
    constructor(props) {
        super(props);
        this.state = this.initialState();
    }

    initialState = () => {
        return {
            error: null,
            loading: true,
            completed: false
        }
    }

    retrieveRestorePassword = () => {
        var rq = { resetToken: queryString.parse(this.props.location.search).p };

        API.Security.get('/recovery/retrieveRestorePassword', rq,
            {
                success: (sr) => {
                    this.setState({
                        loading: false,
                        form: {
                            password: "",
                            confirmPassword: "",
                            securityResponses: []
                        },
                        data: {
                            ...sr.data
                        }
                    }, () => {
                        Modals.authentication(this.state.data.userId);
                    });
                },
                error: (sr) => {
                    this.setState({
                        loading: false,
                        error: sr.error
                    })
                }
            },
            { block: false }
        );
    }

    completeRestorePassword = (e) => {
        if (!this.validate())
            return;

        const rq = {
            newPassword: this.state.form.password,
            securityResponses: this.state.form.securityResponses,
            resetToken: queryString.parse(this.props.location.search).p
        };

        API.Security.post('/recovery/completeRestorePassword', rq,
            {
                success: (sr) => {
                    this.setState({ completed: true });
                },
                error: (sr) => {
                    if (sr.error.errorCode === "INVALID_TOKEN") {
                        this.setState({
                            loading: false,
                            error: sr.error
                        });
                    }
                    else
                        Notifications.error(sr.error.errorMessage);
                }
            });
    }

    validate() {
        const form = this.state.form;

        if (form.password !== form.confirmPassword) {
            this.setState({
                error: "The password and confirmation password do not match."
            });

            return false;
        }

        return true;
    }

    componentDidMount() {
        this.retrieveRestorePassword();
    }

    onChange = (form) => {
        this.setState({ form });
    }

    onSecurityAnswersChange = (value) => {
        this.onChange(Object.assign(this.state.form, { securityResponses: value }));
    }

    render() {
        if (this.state.loading) {
            return (<Loading />)
        }
        else if (this.state.error) {
            return <ValidationError error={this.state.error} />
        }
        else if (this.state.completed) {
            return (<Completed
                title="Password restored."
                message="You have set your new password, and you can safely login now to the application." />)
        }

        return (
            <React.Fragment>
                <p className="login-box-heading">Restore password</p>
                <Form
                    onSubmit={this.completeRestorePassword}
                    values={this.state.form}
                    onChange={this.onChange}>
                    {this.state.data.showSecurityQuestions ?
                        (<Row>
                            <Col sm={12}>
                                <SecurityQuestions
                                    securityQuestions={this.state.data.securityQuestions}
                                    onChange={this.onSecurityAnswersChange} />
                                <hr />
                            </Col>
                        </Row>) : null}
                    <Row>
                        <Col sm={12}>
                            <h4><Glyphicon glyph="menu-right" /> Type your new password</h4>
                        </Col>
                    </Row>
                    <Row>
                        <Col sm={6}>
                            <FormGroup>
                                <Label htmlFor="password" required>New password</Label>
                                <PasswordBox name="password" required />
                            </FormGroup>
                            <FormGroup>
                                <Label htmlFor="confirmPassword" required>Confirm new password</Label>
                                <PasswordBox name="confirmPassword" required />
                            </FormGroup>
                        </Col>
                    </Row>
                    <Row>
                        <Col sm={12}>
                            <PasswordInstructions />
                        </Col>
                    </Row>
                    <hr />
                    <FormGroup className="text-center">
                        <Button id="btnChangePassword" type="submit" bsClass="btn btn-primary btn-flat">Change password</Button>
                    </FormGroup>
                </Form>
            </React.Fragment>
        );
    }
}

export default RestorePassword;



// WEBPACK FOOTER //
// ./src/areas/public/restorePassword/RestorePassword.js